import nextVideoSagas from './next-video/sagas';
import uploadSagas from './upload/sagas';
import conversionSagas from './stream-conversion/sagas';
import cuttingSagas from './cutting/sagas';
import clipDownloadSagas from './clip-download/sagas';

export default [...nextVideoSagas, ...uploadSagas, ...conversionSagas, ...cuttingSagas, ...clipDownloadSagas];
